import isString from "lodash/isString";
import { AnimatePresence } from "framer-motion";
import { List, Stack, Button, IconButton, ListItemText, ListItem, Box } from "@mui/material";
import { UploadMultiFileProps, CustomFile } from "./type";
import Iconify from "../Iconify";
import { varFade } from "../animate";
import { fData } from "src/utils/formatNumber";
import { styled } from "@mui/material";

const ListItemStyle = styled(ListItem)(({ theme }) => ({
    backgroundColor: theme.palette.action.focus,
    padding: theme.spacing(0.75, 2),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(1, 0),
    // border: (theme) => `solid 1px ${theme.palette.divider}`,
}));

const getFileData = (file: CustomFile | string) => {
    if (typeof file === "string") {
        return {
            key: file,
        };
    }
    return {
        key: file.name,
        name: file.name,
        size: file.size,
    };
};

export default function FirmwareFilePreview({
    files,
    onRemove,
    onRemoveAll,
}: UploadMultiFileProps) {
    const hasFile = files.length > 0;

    return (
        <>
            <List disablePadding sx={{ ...(hasFile && { mt: 4, mb: 3 }) }}>
                <AnimatePresence>
                    {files.map((file) => {
                        const { key, name, size } = getFileData(file as CustomFile);

                        return (
                            <ListItemStyle key={key} {...varFade().inRight}>
                                <ListItemText
                                    primary={
                                        <>
                                            <Box
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {isString(file) ? file : name}
                                            </Box>
                                            <Box
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {isString(file)
                                                    ? ""
                                                    : " (" + fData(size || 0) + ")"}
                                            </Box>
                                        </>
                                    }
                                    primaryTypographyProps={{
                                        component: "div",
                                        variant: "subtitle2",
                                        sx: {
                                            color: "text.secondary",
                                            display: "flex",
                                            columnGap: 1,
                                            pr: 3,
                                        },
                                    }}
                                />
                                <IconButton edge="end" size="small" onClick={() => onRemove(file)}>
                                    <Iconify icon={"eva:close-fill"} />
                                </IconButton>
                            </ListItemStyle>
                        );
                    })}
                </AnimatePresence>
            </List>

            {hasFile && (
                <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
                    <Button color="inherit" size="small" onClick={onRemoveAll}>
                        Remove all
                    </Button>
                    <Button size="small" variant="contained">
                        Upload files
                    </Button>
                </Stack>
            )}
        </>
    );
}
